var render = function render(){var _vm=this,_c=_vm._self._c;return _c('top-bar-menu',{attrs:{"title":_vm.$t('common.administration'),"links":_vm.administrationLinks,"permissions-with-default-type":_vm.permissionsWithDefaultType,"content-class":"topbar-menu-administration__content","without-sort":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }